// extracted by mini-css-extract-plugin
export default {"cautionBox":"d_-z"};